import {
  GlobalDesignActionType,
  GlobalDesignGroupAction,
  ComparisonMode,
} from '../types';
import { getBaseManifestProcessingStrategy } from '../common/grouping/getBaseManifestProcessingStrategy';
import { shadowGrouping } from './grouping';
import ShadowLobbyItem from './ShadowLobbyItem';
import ShadowStyles from './ShadowStyles';
import { shadowGroupDisplayFilter } from './groupDisplayFilter';

const shadowAction: GlobalDesignGroupAction = {
  type: GlobalDesignActionType.Group,
  panel: ShadowStyles,
  lobbyItem: ShadowLobbyItem,
  getManifestProcessingStrategy:
    getBaseManifestProcessingStrategy('shadowStyles'),
  groupDisplayFilter: shadowGroupDisplayFilter,
  comparisonMode: ComparisonMode.DirectProps,
  grouping: shadowGrouping,
};

export default shadowAction;
